import { $ as e, C as t, F as n, J as r, S as i, _ as a, g as o, h as s, i as c, l, n as u, nt as d, ot as f, p, q as m, t as h, v as g, w as _, z as v } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as y } from "./i18n-lite-BcmwMblk.js";
import { t as b } from "./normalize-props-DNjMoRjC.js";
//#region src/webcomponents/calcul-impact/locales/de-AT.json
var x = {}, S = {}, C = {}, w = {}, T = {}, E = { "calcul-impact": {
	title: "Calculez votre impact IA",
	subtitle: "Quels ont été vos usages de l'IA la semaine dernière ?",
	numberOfConversationLabel: "Nombre de conversations courtes :",
	numberOfImagesLabel: "Nombre de créations d’images :",
	seePersonalImpact: "Voir votre impact personnel sur une semaine",
	seeCollectiveImpact: "Si 1 million de personnes faisaient comme vous toutes les semaines pendant un an",
	legals: "Estimations basées sur l'étude Hugging Face, Carnegie Mellon University, Allen Institute for AI, Oct 2024",
	yourPersonalImpact: "Votre impact personnel",
	consumptionForAWeek: "Votre consommation sur une semaine",
	consumptionForAYear: "1 million de personnes toutes les semaines pendant un an",
	personalConsumption: "Vous avez consommé environ {{energy}} Wh",
	personalDuration: "Cela équivaut à {{number}} minutes de micro-ondes",
	collectiveConsumption: "Cela représenterait {{energy}} kWh, soit l'équivalent de la consommation en électricité de {{homes}} foyers français",
	collectiveDuration: "Équivalent à {{number}} minutes de micro-ondes",
	planeKilometers: "Et {{kilometers}} km parcourus en avion",
	yourCollectiveImpact: "Impact collectif simulé"
} }, D = {}, O = {}, k = {
	key: 0,
	class: "result-calculation"
}, A = ["aria-level"], j = { class: "consumption" }, M = { style: { "font-weight": "bold" } }, N = { style: { "font-weight": "bold" } }, P = {
	key: 0,
	class: "result-calculation"
}, F = ["titleLevel"], I = { class: "consumption" }, L = { style: { "font-weight": "bold" } }, R = { style: { "font-weight": "bold" } }, z = { style: { "font-weight": "bold" } }, B = { style: { "font-weight": "bold" } }, V = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "ImpactsResults.ce",
	props: {
		titleLevel: { type: Number },
		byWeekForOne: { type: Object },
		byYearForAMillion: { type: Object },
		isPersonal: { type: Boolean },
		isCollective: { type: Boolean }
	},
	setup(e) {
		return (r, o) => {
			let c = v("i18n");
			return n(), g(p, null, [t(u, { name: "fade-perso" }, {
				default: m(() => [e.isPersonal ? (n(), g("div", k, [
					s("div", {
						class: "header",
						role: "heading",
						"aria-level": e.titleLevel + 1
					}, " 📌 " + f(r.$t("calcul-impact.yourPersonalImpact")), 9, A),
					s("p", j, f(r.$t("calcul-impact.consumptionForAWeek")), 1),
					s("p", null, [o[0] ||= i(" ⚡ ", -1), t(c, { t: "calcul-impact.personalConsumption" }, {
						energy: m(() => [s("span", M, f(e.byWeekForOne.energyByWeek), 1)]),
						_: 1
					})]),
					s("p", null, [o[1] ||= i(" 🍽️ ", -1), t(c, { t: "calcul-impact.personalDuration" }, {
						number: m(() => [s("span", N, f(e.byWeekForOne.personalMicrowavesDuration), 1)]),
						_: 1
					})])
				])) : a("", !0)]),
				_: 1
			}), t(u, { name: "fade-collectif" }, {
				default: m(() => [e.isCollective ? (n(), g("div", P, [
					s("div", {
						class: "header",
						role: "heading",
						titleLevel: e.titleLevel + 1
					}, " 🌍 " + f(r.$t("calcul-impact.yourCollectiveImpact")), 9, F),
					s("p", I, f(r.$t("calcul-impact.consumptionForAYear")), 1),
					s("p", null, [o[2] ||= i(" ⚡ ", -1), t(c, { t: "calcul-impact.collectiveConsumption" }, {
						energy: m(() => [s("span", L, f(e.byYearForAMillion.collectiveAnnualEnergy), 1)]),
						homes: m(() => [s("span", R, f(e.byYearForAMillion.equivalentPopulationByCity), 1)]),
						_: 1
					})]),
					s("p", null, [o[3] ||= i(" 🍽️ ", -1), t(c, { t: "calcul-impact.collectiveDuration" }, {
						number: m(() => [s("span", z, f(e.byYearForAMillion.collectiveMicrowavesDuration), 1)]),
						_: 1
					})]),
					s("p", null, [o[4] ||= i(" ✈️ ", -1), t(c, { t: "calcul-impact.planeKilometers" }, {
						kilometers: m(() => [s("span", B, f(e.byYearForAMillion.kilometerByPlane), 1)]),
						_: 1
					})])
				])) : a("", !0)]),
				_: 1
			})], 64);
		};
	}
}), [["styles", [".result-calculation[data-v-b58f44e8]{background:#e0f7fa;border-left:3px solid #00796b;border-radius:10px;padding:1rem}.header[data-v-b58f44e8]{font-size:1.125rem;font-weight:700}.consumption[data-v-b58f44e8]{font-style:italic}.fade-perso-enter-active[data-v-b58f44e8],.fade-collectif-enter-active[data-v-b58f44e8]{transition:all .3s ease-out}.fade-perso-leave-active[data-v-b58f44e8],.fade-collectif-leave-active[data-v-b58f44e8]{transition:all .8s cubic-bezier(1,.5,.8,1)}.fade-perso-enter-from[data-v-b58f44e8],.fade-collectif-enter-from[data-v-b58f44e8],.fade-perso-leave-to[data-v-b58f44e8],.fade-collectif-leave-to[data-v-b58f44e8]{opacity:0;transform:translate(20px)}"]], ["__scopeId", "data-v-b58f44e8"]]), H = { class: "container" }, U = ["arial-level"], W = { for: "numberOfConversation" }, G = { for: "numberOfImage" }, K = { class: "legals" }, q = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "CalculImpact.ce",
	props: { titleLevel: { type: Number } },
	setup(t, { expose: i }) {
		let c = t.titleLevel ?? 2, u = e(10), p = e(2), m = e(0), h = e(0), _ = e(0), v = e(!1), y = e(!1);
		function b() {
			u.value = 10, p.value = 2, S.value = {}, C.value = {}, m.value = 0, h.value = 0, _.value = 0, v.value = !1, y.value = !1, w.value = 0, T.value = 0, E.value = 0, D.value = 0, O.value = 0;
		}
		let x = {
			text: {
				energy: 2.9,
				co2: 1.5
			},
			image: {
				energy: 32,
				co2: 20
			}
		}, S = e({}), C = e({}), w = e(0), T = e(0), E = e(0), D = e(0), O = e(0);
		function k() {
			w.value = u.value * x.text.energy + p.value * x.image.energy, T.value = u.value * x.text.co2 + p.value * x.image.co2, m.value = Number((w.value / .8).toFixed(1)), S.value.energyByWeek = w.value.toFixed(1), S.value.personalMicrowavesDuration = m.value, S.value.co2ByWeek = T.value.toFixed(1);
		}
		function A() {
			E.value = S.value.energyByWeek * 52 * 1e6 / 1e3, D.value = S.value.co2ByWeek * 52 * 1e6 / 1e6, O.value = Math.round(E.value / 2300), h.value = E.value / .8, _.value = D.value * 2410, C.value.collectiveMicrowavesDuration = h.value.toLocaleString(), C.value.kilometerByPlane = _.value.toLocaleString(), C.value.equivalentPopulationByCity = O.value.toLocaleString(), C.value.collectiveAnnualEnergy = E.value.toLocaleString();
		}
		function j() {
			k(), v.value = !0;
		}
		function M() {
			A(), y.value = !0;
		}
		function N() {
			v.value && y.value && (k(), A());
		}
		return i({ reset: b }), (e, t) => (n(), g("div", H, [
			s("div", {
				class: "title",
				role: "heading",
				"arial-level": d(c)
			}, " 📊 " + f(e.$t("calcul-impact.title")), 9, U),
			s("p", null, f(e.$t("calcul-impact.subtitle")), 1),
			s("label", W, "🤖 " + f(e.$t("calcul-impact.numberOfConversationLabel")), 1),
			r(s("input", {
				id: "numberOfConversation",
				"onUpdate:modelValue": t[0] ||= (e) => u.value = e,
				type: "number",
				onChange: N
			}, null, 544), [[l, u.value]]),
			s("label", G, "🖼️ " + f(e.$t("calcul-impact.numberOfImagesLabel")), 1),
			r(s("input", {
				id: "numberOfImage",
				"onUpdate:modelValue": t[1] ||= (e) => p.value = e,
				type: "number",
				onChange: N
			}, null, 544), [[l, p.value]]),
			v.value ? (n(), o(V, {
				key: 0,
				"is-collective": y.value,
				"is-personal": v.value,
				"title-level": d(c),
				"by-week-for-one": S.value,
				"by-year-for-a-million": C.value
			}, null, 8, [
				"is-collective",
				"is-personal",
				"title-level",
				"by-week-for-one",
				"by-year-for-a-million"
			])) : a("", !0),
			v.value ? a("", !0) : (n(), g("button", {
				key: 1,
				onClick: j
			}, " 📌 " + f(e.$t("calcul-impact.seePersonalImpact")), 1)),
			v.value && !y.value ? (n(), g("button", {
				key: 2,
				onClick: M
			}, " 🌍 " + f(e.$t("calcul-impact.seeCollectiveImpact")), 1)) : a("", !0),
			s("p", K, " 📝 " + f(e.$t("calcul-impact.legals")), 1)
		]));
	}
}), [["styles", ["[data-v-61643738]{color:#253858;font-family:Nunito,Roboto,sans-serif}p[data-v-61643738]{padding:0}.container[data-v-61643738]{flex-direction:column;gap:1rem;display:flex}.container button[data-v-61643738]{color:#fff;cursor:pointer;background:#357abd;border:0;border-radius:5px;width:50%;margin:auto;padding:.4rem .8rem;font-size:.9rem}.container button[data-v-61643738]:hover{background:#225d93}.container input[data-v-61643738]{border:1px solid #d3d3d3;border-radius:5px;width:40%;padding-block:.2rem}.container label[data-v-61643738]{font-weight:700}.container .legals[data-v-61643738]{font-size:.9rem;font-style:italic}.container .title[data-v-61643738]{font-size:1.3rem;font-weight:700}@media only screen and (width<=768px){.container button[data-v-61643738]{width:100%}.container input[data-v-61643738]{width:80%}}"]], ["__scopeId", "data-v-61643738"]]);
//#endregion
//#region src/webcomponents/calcul-impact/calcul-impact.ce.js
y.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": x,
	"./locales/en.json": S,
	"./locales/es-419.json": C,
	"./locales/es.json": w,
	"./locales/fr-BE.json": T,
	"./locales/fr.json": E,
	"./locales/it.json": D,
	"./locales/nl.json": O
}));
var J = c(q, { configureApp(e) {
	y.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(y);
} });
J.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: b(e.titleLevel)
}), window.customElements.define("calcul-impact", J);
//#endregion
